/** Clases de los botones de la pantalla de feedback (se combinan con `cn`). */
export const accionSecundaria =
  "h-9 px-3 rounded-lg normal-case text-sm font-semibold border border-[var(--primary)] text-[var(--primary)] bg-transparent hover:bg-[var(--primary)]/10";

export const accionPrincipal =
  "h-9 px-4 rounded-lg normal-case text-sm font-semibold bg-[var(--primary)] text-white hover:bg-[var(--primary)]/90";
